import { Fragment } from 'react';

import {
  EntityResourceLinkExtension,
  FactTableResourceLinkExtension,
} from '@spotify/plugin-confidence-admin';
import {
  ChatResourceLinkExtension,
  ProjectChatResourceLinkExtension,
} from '@spotify/plugin-confidence-chat';
import { IdentityResourceLinkExtension } from '@spotify/plugin-confidence-iam';
import {
  MeasurementResourceLinkExtension,
  MetricResourceLinkExtension,
} from '@spotify/plugin-confidence-metrics';
import { ProjectResourceLinkExtension } from '@spotify/plugin-confidence-projects';
import { SurfaceResourceLinkExtension } from '@spotify/plugin-confidence-surfaces';
import { WorkflowInstanceResourceLinkExtension } from '@spotify/plugin-confidence-workflows';

export const defaultResourceLinkExtensionElements = (
  <Fragment>
    <ChatResourceLinkExtension />
    <ProjectChatResourceLinkExtension />
    <IdentityResourceLinkExtension />
    <MetricResourceLinkExtension />
    <MeasurementResourceLinkExtension />
    <EntityResourceLinkExtension />
    <FactTableResourceLinkExtension />
    <ProjectResourceLinkExtension />
    <SurfaceResourceLinkExtension />
    <WorkflowInstanceResourceLinkExtension />
  </Fragment>
);

export const DefaultResourceLinkExtensions = () =>
  defaultResourceLinkExtensionElements;
